export default function useValidators(): any {
    const isRequired = (value: string): boolean | string => {
        return value && value.trim() ? true : 'This is required';
    };

    const isEmail = (value: string): boolean | string => {
        return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ? true : 'This must be a valid email';
    };

    const isMinLen = (value: string, length: number): boolean | string => {
        return value.length >= length ? true : `Must be at least ${length} characters`;
    };

    const isMaxLen = (value: string, length: number): boolean | string => {
        return value.length <= length ? true : `Must be no more than ${length} characters`;
    };

    const isOneOf = (value: string, options: Array<string>): boolean | string => {
        return options.includes(value) ? true : `Must be one of these options: { ${options.join(', ')} }`;
    };

    return {
        isRequired,
        isEmail,
        isMinLen,
        isMaxLen,
        isOneOf
    };
}
